import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { ApplicationAdapter } from 'application/application.adapter';
import { ModuleColumn } from 'module/column/module-column';
import { ModuleColumnI18n } from 'module/column/module-column-i18n';
import { ModuleOutput } from 'module/model/module.output';
import { Module } from 'module/module';
import { ModuleDependency } from 'module/module-dependency';
import { ModuleI18n } from 'module/module-i18n';
import { ModuleOption } from 'module/module-option';
import { ModuleConverterPort } from 'module/port/module-converter.port';

@Injectable()
export class ModuleConverterAdapter
	extends ApplicationAdapter
	implements ModuleConverterPort
{
	public moduleAsEntity(output: ModuleOutput): Module {
		if (!output) {
			return null;
		}
		return new Module(
			output.id,
			output.canTriggerAnswersDocument,
			output.averageSpentTime,
			output.averageSpentDays,
			output.phaseId,
			output.moduleId,
			output.type,
			output.position,
			(output.pages || []).map((page) => page.id),
			output.sectionId,
			output.redirectUrl,
			(output.articles || []).map((article) => article.id),
			output.hasSettings,
			output.pushOrgModuleId,
			output.organizationId,
			(output.columns || []).map(
				(column) =>
					new ModuleColumn(
						column.id,
						column.position,
						column.localizations.map(
							(loc) => new ModuleColumnI18n(loc.name, loc.locale)
						)
					)
			),
			output.updateTimestamp,
			output.isVisibleInPlan,
			output.linkedGraphsId || [],
			(output.localizations || []).map(
				(loc) =>
					new ModuleI18n(
						loc.name,
						loc.title,
						loc.locale,
						loc.videoId,
						loc.description,
						loc.suggestionText,
						loc.averageDuration,
						(loc.options || []).map(
							(option) =>
								new ModuleOption(
									option.label,
									option.value,
									option.groupName,
									option.position
								)
						)
					)
			),
			output.linkedQuestionsId || [],
			output.excludedQuestionsId || [],
			(output.dependencies || []).map(
				(dependency) =>
					new ModuleDependency(
						dependency.moduleId,
						dependency.dependencyId,
						dependency.type
					)
			)
		);
	}

	public modulesAsEntities(outputs: ModuleOutput[]): Module[] {
		return reject(outputs, isNil).map((output) => this.moduleAsEntity(output));
	}
}
